import { useEffect, useState } from "react";
import { ModalSimple } from "../../../../core/components/Modal";
import ReactDOM from "react-dom";
import { WarningBG } from "../../../../core/icons/Warning";
import { Likes } from "../../../match/domain/entities/userMatch";
import InfoNotificationAdmin from "../../domain/entities/InfoNotificationAdmin";

interface NotificationModalProps {
	isOpen: boolean;
	category: "like" | "match" | "alert" | "myLikes";
	notification: Likes | InfoNotificationAdmin;
	onClose: () => void;
	onConfirm: () => void;
	isLikedSwiped?: boolean;
}

export const ConfirmationModal: React.FC<NotificationModalProps> = ({ isOpen, category, notification, onClose, onConfirm, isLikedSwiped = false }) => {
	const [title, setTitle] = useState("");
	const [message, setMessage] = useState("");

	useEffect(() => {
		if (!isOpen) return;

		const modalContent = {
			like: {
				title: isLikedSwiped ? "Add Like" : "Remove Like",
				message: isLikedSwiped
					? `Are you sure you want to add a like for ${(notification as Likes).username}?`
					: `Are you sure you want to remove the like for ${(notification as Likes).username}?`,
			},
			match: {
				title: "Remove Match",
				message: `Are you sure you want to remove the match with ${(notification as Likes).username}?`
			},
			myLikes: {
				title: "Remove My Like",
				message: `Are you sure you want to remove your like for ${(notification as Likes).username}?`,
			},
			alert: {
				title: "Remove Alert",
				message: `Are you sure you want to remove this alert?`,
			},
		};

		const { title, message } = modalContent[category];
		setTitle(title);
		setMessage(message);
	}, [category, isOpen, isLikedSwiped, notification]);

	return (
		<>
			{ReactDOM.createPortal(
				<ModalSimple
					title={title}
					variant="secondary"
					actionExecuted={isOpen}
					onClose={onClose}
					onAction={onConfirm}
					icon={<WarningBG />}
				>
					<p>{message}</p>
				</ModalSimple>,
				document.getElementById("root") as HTMLElement
			)}
		</>
	);
};
